import type React from 'react';
import { LiaStar, LiaStarHalf, LiaStarSolid } from 'react-icons/lia';

export interface RatingStarProps extends React.ComponentPropsWithoutRef<'svg'> {
  state?: 'full' | 'half' | 'empty';
}

export function RatingStar({ state = 'full', ...otherProps }: RatingStarProps) {
  return state === 'full' ? (
    <LiaStarSolid {...otherProps} />
  ) : state === 'half' ? (
    <LiaStarHalf {...otherProps} />
  ) : (
    <LiaStar {...otherProps} />
  );
}
